import ApiService from '@/services/api.service';

const ProviderCodesService = {
    getAll() {
        const requestData = {
            method: 'get',
            url: '/ProviderCodes',
            headers: {},
            params: {}
        };
        return ApiService.customRequest(requestData);
    },

   
    getHealthcareServiceLocation(parameter) {
        const requestData = {
            method: 'get',
            url: '/ProviderCodes/HealthcareServiceLocation',
            headers: {},
            params: {
                Code: parameter.code,
                PageSize: parameter.PageSize,
                PageNumber: parameter.PageNumber,
            }
        };
        return ApiService.customRequest(requestData);
    },

    getTimeZone(parameter) {
        const requestData = {
            method: 'get',
            url: '/TimeZones',
            headers: {},
            params: {
                Code: parameter.code,
                PageSize: parameter.PageSize,
                PageNumber: parameter.PageNumber,
            }
        };
        return ApiService.customRequest(requestData);
    },

};

export default ProviderCodesService;
